const quilts: {
  name: string
  path: string
  scale: [number, number]
}[] = [
  {
    name: 'Squares',
    path: 'pattern-1.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Square Diamond',
    path: 'pattern-3.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Flat Diamonds',
    path: 'pattern-4.sdq',
    scale: [1, 1],
  },
  {
    name: 'Flat Diamonds',
    path: 'diamond1.sdq',
    scale: [1, 1],
  },
  {
    name: 'Flat Diamonds',
    path: 'diamond2.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Flat Diamonds',
    path: 'diamond3.sdq',
    scale: [1.4, 1.4],
  },
  {
    name: 'Flat Diamonds',
    path: 'square1.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Flat Diamonds',
    path: 'diamond5.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Parallel Bridge 3',
    path: 'bridge-3.sdq',
    scale: [0.6, 0.6],
  },
  {
    name: 'Parallel Bridge 6',
    path: 'bridge-6.sdq',
    scale: [0.6, 0.6],
  },
  {
    name: 'WAVE Horizontal',
    path: 'Sin_H.sdq',
    scale: [1, 1],
  },
  {
    name: 'WAVE Verical',
    path: 'Sin_V.sdq',
    scale: [1, 1],
  },
  {
    name: 'Diagonal',
    path: 'diag_sq.sdq',
    scale: [0.6, 0.6],
  },
  {
    name: 'Vertical',
    path: 'vertical.sdq',
    scale: [1, 1],
  },
  {
    name: 'Horizontal',
    path: 'horizontal.sdq',
    scale: [1, 1],
  },
  {
    name: 'Hexagon',
    path: 'hex.sdq',
    scale: [0.3, 0.3],
  },
  {
    name: 'Wave1',
    path: 'waves_1.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Wave2',
    path: 'waves_2.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Wave3',
    path: 'waves_3.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'Wave4',
    path: 'waves_4.sdq',
    scale: [1.2, 1.2],
  },
  {
    name: 'fence1',
    path: 'fence_1.sdq',
    scale: [0.5, 0.5],
  },
  {
    name: 'fence2',
    path: 'fence_2.sdq',
    scale: [0.5, 0.5],
  },
  {
    name: 'fence3',
    path: 'fence_3.sdq',
    scale: [0.3, 0.3],
  },
  {
    name: 'fence4',
    path: 'fence_4.sdq',
    scale: [0.25, 0.25],
  },
  {
    name: 'fence5',
    path: 'fence_5.sdq',
    scale: [0.2, 0.2],
  },
  {
    name: 'triangle1',
    path: 'triangles_1.sdq',
    scale: [0.2, 0.2],
  },
  {
    name: 'Diagonal1',
    path: 'diagonal_1.sdq',
    scale: [0.25, 0.25],
  },
  {
    name: 'Diagonal2',
    path: 'diagonal_2.sdq',
    scale: [0.25, 0.25],
  },
]

export default quilts
